/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
        controller('WebSiteCheckOutCtrl',["$log","$scope", "$rootScope","$window","CustomerView","CustomerSrv",
                    "CustomerData","Customer","WebPreLoaderData","Auth","$timeout","CookieFactory","BookingData","OptInOut",
                    "gettextCatalog","CureItemData", "CureItemSrv","SalePaymentType","BookingView","SaleDelivery", "Constants",
                    "WebsiteConstants", "bugsnag",
        function($log,$scope, $rootScope,$window,CustomerView,CustomerSrv,CustomerData,Customer,WebPreLoaderData,Auth,
                 $timeout,CookieFactory,BookingData,OptInOut, gettextCatalog, CureItemData, CureItemSrv, SalePaymentType,
                 BookingView, SaleDelivery, Constants, WebsiteConstants, bugsnag) {

        //Categories.query($scope,false);
        mangoPay.cardRegistration.clientId = "flexybeauty";
        if ($scope.ad.applicationId=="bsiflexyprod")
            mangoPay.cardRegistration.baseURL = "https://api.mangopay.com";

        $scope.dd =
        {
            view :
            {
                productsOfServicesView : [],
                displayError : false,
                isSmsActivationCodeValidated : false,
                isSmsActivationCodeSent : false,
                smsActivationCode : null,
                cureDisplayError: false,
                waitServerResponse:false,
                errorMessage :null,
                errorStockMessage : null,
                emailErrorMessage : null,
                serverAlert : false,
                displayStep : 'connect',//1 / 2 / 3 /  4
                displayCantSendSms : false,
                cookieError : false,
                savingDone : false,
                errorFinal : false,
                loading : true,
                customerEmailConfirmation : "",
                emailConfirmation : "",
                isWithoutPayment : false,
                checkoutDisplaySteps: WebsiteConstants.checkoutDisplaySteps,
                process : {
                     connect : {
                         active : true,
                        num:1
                     },
                     sms : {
                        active : false,
                        num:0
                    },
                    identity : {
                        active : true,
                        num:2
                    },
                    card : {
                        active : false,
                        num:0
                    },
                    emailValidation : {
                         active : false,
                         num : 0
                    },
                    recap : {
                        active : true,
                        num:3
                    }

                },
                card : {
                    formValidity : {
                        displayError : false,
                        global : false,
                        number : false,
                        expiration : false,
                        cvx : false,
                        onChangeNumber : function (number){
                            this.number = false;
                            if (number && number.length==16 && /^\d+$/.test(number))
                                this.number = true;
                            this.global = this.number && this.expiration & this.cvx;
                        },
                        onChangeExpiration : function (month,year){
                            this.expiration = (month !="00" && year !="00");
                            this.global = this.number && this.expiration & this.cvx;
                        },
                        onChangeCvx : function (cvx){
                            this.cvx = false;
                            if (cvx && cvx.length==3 && /^\d+$/.test(cvx))
                                this.cvx = true;
                            this.global = this.number && this.expiration & this.cvx;
                        }
                    },
                    registrationInitialized : false,
                    registerProcessing : false,
                    data : {
                        cardNumber: "",
                        cardExpirationDateMonth :"00",
                        cardExpirationDateYear :"00",
                        cardCvx: "",
                        cardType: "CB_VISA_MASTERCARD"
                    }
                }
            },
            smsActivationCodeSent : null,
            emailRegex : Constants.EMAIL
        };

        if ($scope.ad.appAttributes.googleAnalyticsId && $scope.ad.appAttributes.googleAnalyticsId!='') {
            let dataLayer = $window.dataLayer = $window.dataLayer || [];
            dataLayer.push({event: 'page_change',
                attributes: {
                    route: '/rendezvous/formulaire'
                },
            });
        }

        if (typeof analytics !== 'undefined' && analytics) {
            analytics.track("Booking Demo Signed Up Form");
        }

        $scope.initProcess = function() {
            let start = 2;
            $scope.dd.view.customerEmailConfirmation = $scope.ad.view.customerView.email;
            $scope.dd.view.emailErrorMessage = null;
            if ($scope.ad.customerConnected) {
                $scope.dd.view.process.connect.active = false;
                start = 1;
            }
            $scope.dd.view.process.identity.num = start;
            $scope.dd.view.process.recap.num =  start +1;

            if ($scope.ad.view.currentSaleView && !$scope.ad.view.currentBookingView) {
                $scope.dd.view.process.sms.active = false;
                $scope.dd.view.process.sms.num = 0;
                $scope.dd.view.process.recap.num = start +1;
                $scope.addCartToProcess();
                $scope.addEmailValidationToProcessIfNeeded();
            }
            else {
                if ($scope.ad.view.currentSaleView && $scope.hasMandatoryPayment() || $scope.mustPayAdvance()) {
                    $scope.addCartToProcess();
                    $scope.addEmailValidationToProcessIfNeeded();
                } else {
                    if ($scope.ad.subscriptionsStatus.bookingSmsSecurity && !$scope.ad.customerConnected) {
                        $scope.dd.view.process.sms.active = true;
                        $scope.dd.view.process.sms.num = start;
                        $scope.dd.view.process.identity.num = start + 1;
                        $scope.dd.view.process.recap.num = start + 2;
                    }
                }
            }

            if ($scope.ad.view.currentSaleView) {
                $scope.ad.view.currentSaleView.calculateSaleFields();
            }
        };

        $scope.addCartToProcess = function () {
            $scope.dd.view.process.card.num = $scope.dd.view.process.recap.num + 1;
            if ($scope.dd.view.process.emailValidation.active) {
                $scope.dd.view.process.card.num += 1;
            }
            $scope.dd.view.process.card.active = true;
        };

        $scope.goToRegisterTab  = function() {
            if ($scope.dd.view.process.sms.active)
                $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.sms;
            else
                $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.identity;
        };

        $scope.login = function() {
            //if (!$scope.ad.view.customerView.email)
            //$scope.ad.view.customerView.email ="m@m.fr";
            if ($scope.ad.view.customerView && !$scope.dd.view.waitServerResponse)
                if ($scope.ad.view.customerView.canLoginOnWeb())
                {
                    $scope.dd.view.waitServerResponse = true;
                    var customer = new Customer();
                    if ($scope.ad.view.customerView.login && $scope.ad.view.customerView.login!='')
                        if ($scope.ad.view.customerView.login.indexOf("@")!=-1)//email
                            customer.email = $scope.ad.view.customerView.login;
                        else
                            customer.phone = $scope.ad.view.customerView.login;
                    customer.password =  $scope.ad.view.customerView.password;
                    Auth.loginToWebSite(WebPreLoaderData.companyCode,customer,
                        function () {
                            //Success login get Customer data from it

                            CustomerSrv.getData(customer,$scope.afterLoginSuccess,$scope.afterLoginError);
                        },$scope.afterLoginError);
                }
                else
                    $scope.dd.view.displayError = true;
        };

        $scope.validateSmsActivationCode = function() {
            if($scope.dd.smsActivationCodeSent == $scope.dd.view.smsActivationCode)
            {
                $scope.dd.view.isSmsActivationCodeValidated = true;
                $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.identity;
                $scope.dd.view.displayError = false;
                $scope.ad.view.customerView.isVerified = true;
            }
            else
                $scope.dd.view.displayError = true;
        };

        $scope.register = function() {
            if ($scope.ad.view.customerView && !$scope.dd.view.waitServerResponse)
                if ($scope.ad.view.customerView.canRegisterOnWeb(true))
                {
                    $scope.dd.view.waitServerResponse = true;
                    var customer = new Customer();
                    $scope.ad.view.customerView.copyDataTo(customer);

                    customer.optInOut = new OptInOut({
                        isSmsCampaignAllowed : $scope.ad.view.customerView.optInOutView.isSmsCampaignAllowed,
                        isEmailCampaignAllowed : $scope.ad.view.customerView.optInOutView.isEmailCampaignAllowed,
                        isNotificationCampaignAllowed  : $scope.ad.view.customerView.optInOutView.isNotificationCampaignAllowed
                    });

                    Auth.registerToWebSite(customer,WebPreLoaderData.companyCode,$scope.afterLoginSuccess,$scope.afterLoginError);
                }
                else
                    $scope.dd.view.displayError = true;
        };

        $scope.updateCustomer  = function() {
            if ($scope.ad.view.customerView && !$scope.dd.view.waitServerResponse)
                if ($scope.ad.view.customerView.canRegisterOnWeb(false))
                {
                    $scope.dd.view.waitServerResponse = true;
                    $scope.ad.view.customerView.updateModel(true,function(){
                        $scope.dd.view.waitServerResponse = false;
                        $scope.dd.view.errorMessage = null;
                        $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.recap;
                    })
                }
                else
                    $scope.dd.view.displayError = true;
        };

        $scope.afterLoginSuccess = function(customer) {
            $scope.dd.view.waitServerResponse = false;
            $scope.dd.view.errorMessage = null;
            if (customer!=null)
            {
                $scope.ad.view.customerView.cIndex = CustomerData.getIndexOf(customer);
                $scope.ad.view.customerView.loadDataFrom(customer);
                CustomerSrv.loadRelatedData($scope.ad.view.customerView.getModel(), function (){
                    if ($scope.ad.view.currentBookingView)
                        $scope.ad.view.currentBookingView.bookingIndex =-1;//reinit because loadRelatedData clear index
                    if ($scope.ad.view.currentSaleView)
                        $scope.ad.view.currentSaleView.saleIndex =-1;//reinit  because loadRelatedData clear index
                    $scope.ad.view.customerView.initHistoryView();
                    if ($scope.ad.view.currentSaleView){
                        $scope.ad.view.currentSaleView.updateLoyaltyCardItem(true);
                    }
                    if($scope.ad.view.currentBookingView && $scope.ad.view.currentBookingView.bookingServicesView){
                        $scope.ad.view.currentBookingView.updateBookingsServicesFromCustomerCures($scope.ad.view.customerView)
                    }
                    $scope.dd.view.loading = false;
                    $scope.ad.view.customerView.password = null;//hide by security
                    $scope.ad.customerConnected = true;
                    if (!$scope.ad.view.customerView.email || $scope.ad.view.customerView.email == '') {
                        alert("Vous devez indiquer un email dans 'Mon compte'");
                        return;
                    }
                    $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.recap;
                },function() {
                    $scope.ad.view.currentBookingView = null;
                    $scope.ad.view.currentSaleView = null;
                    $scope.dd.view.errorMessage = "Le système de paiement n'est pas disponible."
                    $scope.dd.view.loading = false;
                });
            }
        };

        $scope.getCardRegistration = function() {
            if ($scope.ad.view.currentSaleView) {
                $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.card;
                CustomerSrv.getCardRegistration($scope.ad.view.customerView.getModel(),function (cardRegistration) {
                    if (cardRegistration)
                    {
                        mangoPay.cardRegistration.init({
                            cardRegistrationURL: cardRegistration.cardRegistrationURL,
                            preregistrationData: cardRegistration.preregistrationData,
                            accessKey: cardRegistration.accessKey,
                            Id: cardRegistration.id
                        });
                        $scope.dd.view.card.registrationInitialized = true;
                    }
                },function (message) {
                    console.log(message);
                    bugsnag.notify("WebsiteCheckOut.getCardRegistration - cardRegistration failed", "error message: " + message, {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
                    $scope.dd.view.errorMessage = gettextCatalog.getString("Une erreur est survenue lors de l'obtention du formulaire d'enregistrement de la carte. ");
                });
            }
        };

        $scope.paidCheckOutBooking = function(status) {
            if ($scope.ad.view.currentBookingView!=null) {
                $scope.ad.view.currentSaleView.status=status;
                if ($scope.ad.view.currentSaleView.status=="advanceProcess")
                    $scope.ad.view.currentSaleView.currentPayment = $scope.ad.view.currentSaleView.price * $scope.ad.appAttributes.bookingPaymentAdvancePercent/100;
                else
                    $scope.ad.view.currentSaleView.currentPayment = $scope.ad.view.currentSaleView.price;
                $scope.ad.view.currentSaleView.paymentsView = [];
                $scope.ad.view.currentSaleView.change =0;
                $scope.ad.view.currentSaleView.payedPrice = 0;
                $scope.ad.view.currentSaleView.addPaymentView(SalePaymentType.CBONLINE.type);
                $scope.getCardRegistration();
                $scope.addCartToProcess();
                $scope.addEmailValidationToProcessIfNeeded();
            }
        };

        $scope.addEmailValidationToProcessIfNeeded = function() {
            if ($scope.ad.view.customerView.email && !$scope.isValidCustomerEmail()) {
                if (!$scope.dd.view.isWithoutPayment) {
                    $scope.dd.view.process.emailValidation.num = $scope.dd.view.process.card.num;
                    $scope.dd.view.process.card.num += 1;
                } else {
                    $scope.dd.view.process.emailValidation.num = $scope.dd.view.process.recap.num + 1;
                }
                $scope.dd.view.process.emailValidation.active = true;
                $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.emailValidation;
            }
        };

        $scope.paidCheckOutGift = function() {
            if (isNaN($scope.ad.view.currentSaleView.price)) {
                $scope.dd.view.errorFinal = true;
                $scope.dd.view.waitServerResponse = false;
                $scope.ad.view.currentSaleView = null;
                $scope.ad.view.currentBookingView = null;
                $scope.dd.view.errorMessage = "Montant incorrect, impossible d'effectuer la transaction.";
            }
            else if ($scope.ad.view.currentSaleView != null && $scope.ad.view.currentSaleView.customerView != null) {
                if ($scope.ad.view.currentSaleView.price != 0) {
                    if ($scope.ad.view.currentSaleView.delivery === "address" && !$scope.ad.view.currentSaleView.customerView.hasAddress()) {
                        $scope.dd.view.errorMessage = "L'adresse de livraison n'est pas correcte";
                        return;
                    } else {
                        $scope.dd.view.errorMessage = null;
                    }
                    $scope.ad.view.currentSaleView.status = "soldProcess";
                    $scope.ad.view.currentSaleView.currentPayment = $scope.ad.view.currentSaleView.price;
                    $scope.ad.view.currentSaleView.paymentsView = [];
                    $scope.ad.view.currentSaleView.change = 0;
                    $scope.ad.view.currentSaleView.payedPrice = 0;
                    $scope.ad.view.currentSaleView.addPaymentView(SalePaymentType.CBONLINE.type);
                    $scope.getCardRegistration();
                    $scope.addCartToProcess();
                    $scope.addEmailValidationToProcessIfNeeded();
                }
                else {
                    $scope.ad.view.currentSaleView.status  = "sold";
                    $scope.ad.view.currentSaleView.updateModel(null,
                        function (data) {
                            $scope.dd.view.waitServerResponse = false;
                            $scope.dd.view.savingDone = true;
                            $scope.dd.view.errorMessage = null;
                            $scope.ad.view.soldSaleView = $scope.ad.view.currentSaleView;
                            $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
                            $scope.ad.view.currentSaleView = null;
                            $scope.ad.view.currentBookingView = null;
                            $scope.openLocation("account");
                        },
                        function (res) {
                            console.log(res);
                            if (res && res.data && res.data.errorCode =="40900")
                                $scope.dd.view.errorMessage = "La vente a été refusée. Merci de charger à nouveau le site internet et d'essayer à nouveau.";
                            else
                                $scope.dd.view.errorMessage = "La transaction a été refusée.";
                            $scope.dd.view.errorFinal = true;
                            $scope.dd.view.waitServerResponse = false;
                            $scope.ad.view.currentSaleView = null;
                            $scope.ad.view.currentBookingView = null;
                        });
                }
            }
        };

        $scope.afterLoginError = function(errorCode,errorMessage) {
            console.log(errorMessage);
            $scope.dd.view.errorMessage = errorMessage;
            $scope.dd.view.waitServerResponse = false;
        };

        $scope.registerCard  = function() {
            $scope.dd.view.errorMessage =null;
            if (!$scope.dd.view.card.formValidity.global)
                $scope.dd.view.card.formValidity.displayError = true;
            else
            {
                if (!$scope.dd.view.card.registrationInitialized || $scope.dd.view.waitServerResponse)
                {
                    $timeout(function() {$scope.dd.view.errorMessage = "Merci d'essayer à nouveau, le système de paiement n'était pas disponible."},2000);
                }
                else {
                    // Register card
                    $scope.dd.view.waitServerResponse = true;
                    var cardData = {
                        cardNumber:$scope.dd.view.card.data.cardNumber,
                        cardExpirationDate: $scope.dd.view.card.data.cardExpirationDateMonth+$scope.dd.view.card.data.cardExpirationDateYear,
                        cardCvx: $scope.dd.view.card.data.cardCvx,
                        cardType: "CB_VISA_MASTERCARD"
                    };
                    mangoPay.cardRegistration.registerCard(cardData,function(res) {
                            if (res.CardId)
                            {
                                $scope.ad.view.currentSaleView.paymentCardId = res.CardId;
                                if ($scope.ad.view.currentBookingView)
                                    $scope.saveCurrentBooking();
                                else
                                    $scope.commitSale();

                            }
                            else
                            {
                                $scope.dd.view.errorMessage   = "Echec de validation. Merci d'essayer à nouveau.";
                                $scope.getCardRegistration();
                                $scope.dd.view.waitServerResponse = false;
                            }

                            $scope.$apply();
                        },
                        function(res) {
                            // Handle error, see res.ResultCode and res.ResultMessage
                            switch(res.ResultCode) {
                                case "105101":
                                    $scope.dd.view.errorMessage   = "Numéro de carte invalide";
                                    break;
                                case "105102":
                                    $scope.dd.view.errorMessage   = "Possesseur de la carte invalide";
                                    break;
                                case "105103":
                                    $scope.dd.view.errorMessage   = "Code pin invalide";
                                    break;
                                case "105104":
                                    $scope.dd.view.errorMessage   = "Code pin invalide";
                                    break;
                                case "105202":
                                    $scope.dd.view.errorMessage   = "Numéro de carte invalide";
                                    break;
                                case "105203":
                                    $scope.dd.view.errorMessage   = "Date d'expiration invalide";
                                    break;
                                case "105204":
                                    $scope.dd.view.errorMessage   = "Code sécurité invalide";
                                    break;
                                default:
                                    $scope.dd.view.errorMessage   = res.ResultCode + " "  + res.ResultMessage + " - " + gettextCatalog.getString("Contactez le support") + " " + ".";
                            }
                            $scope.dd.view.waitServerResponse = false;
                            $scope.$apply();
                        }
                    );

                    //Generate barcode if needed
                    var giftItemView ;
                    if ($scope.ad.view.currentSaleView && $scope.ad.view.currentSaleView.giftItemsView.length!=0)
                    {
                        giftItemView =   $scope.ad.view.currentSaleView.giftItemsView[0];
                        $scope.ad.view.currentSaleView.giftItemsView[0].updateModel(true, function() {
                            var elm =  $("#barcode");
                            if (elm && elm[0])
                            {
                                giftItemView.updateFromModel();
                                var giftItem = giftItemView.getModel();
                                if (giftItem)
                                {
                                    elm.JsBarcode(giftItem.code,{format:"EAN",displayValue:false,fontSize:16,height: 30});
                                    giftItemView.barcodeData = elm[0].currentSrc;
                                }
                            }
                        })
                    }
                }
            }
        };

        $scope.commitSale = function(  ) {
            if ($scope.ad.view.currentSaleView) {
                if ($scope.ad.view.currentSaleView.paymentCardId) {
                    $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
                    $scope.dd.view.savingDone = false;
                    $scope.dd.view.waitServerResponse = true;
                    $scope.ad.view.currentSaleView.updateModel(null,
                        function (data) {
                            $scope.dd.view.waitServerResponse = false;
                            $scope.dd.view.savingDone = true;
                            $scope.dd.view.errorMessage = null;
                            if (data.sales && data.sales.length == 1) {

                                var sale = data.sales[0];
                                if (sale.resultPayIn) {
                                    if (sale.resultPayIn.secureModeRedirectURL && sale.resultPayIn.secureModeRedirectURL != '') {
                                        $scope.dd.view.errorMessage = "Redirection vers site 3D secure";
                                        $window.open(sale.resultPayIn.secureModeRedirectURL, "_self");
                                    }
                                    else {
                                        if ($scope.ad.view.currentSaleView && $scope.ad.view.currentSaleView.bookingView && $scope.ad.appAttributes.googleAnalyticsId && $scope.ad.appAttributes.googleAnalyticsId!='')
                                            ga('send', 'pageview', '/rendezvous/finalise')
                                        if (typeof analytics !== 'undefined' && analytics)
                                            analytics.track("Booking Demo Signed Up");

                                        $scope.ad.view.soldSaleView = $scope.ad.view.currentSaleView;
                                        $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
                                        $scope.ad.view.currentSaleView = null;
                                        $scope.ad.view.currentBookingView = null;
                                        if (sale.resultPayIn.status == "FAILED") {
                                            $scope.dd.view.errorMessage = "La transaction a été refusée par la banque. Merci de vérifier vos autorisations de paiement par Internet";
                                            $scope.dd.view.errorFinal = true;
                                        }
                                        else if(sale.resultPayIn.status == "CURRENCY_ERROR"){
                                            $scope.dd.view.errorMessage = "La transaction a rencontrée un problème. Merci de contacter le propriétaire du site web.";
                                            $scope.dd.view.errorFinal = true;
                                        }
                                        else {
                                            $scope.openLocation("account");
                                        }
                                    }
                                }
                                else
                                {
                                    $scope.ad.view.soldSaleView = $scope.ad.view.currentSaleView;
                                    $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
                                    $scope.ad.view.currentSaleView = null;
                                    $scope.ad.view.currentBookingView = null;
                                    $scope.dd.view.errorMessage = "La transaction a échoué suite à un problème technique.";
                                    $scope.dd.view.errorFinal = true;
                                }

                            }

                        },
                        function (res) {
                            console.log(res);
                            if (res && res.data && res.data.errorCode =="40900")
                                $scope.dd.view.errorMessage = "La vente a été refusée. Merci de charger à nouveau le site internet et d'essayer à nouveau..";
                            else
                                $scope.dd.view.errorMessage = "La transaction a été refusée. Merci de vérifier vos autorisations de paiement par internet. Puis de charger à nouveau le site internet et d'essayer à nouveau.";
                            $scope.dd.view.errorFinal = true;
                            $scope.dd.view.waitServerResponse = false;
                            $scope.ad.view.currentSaleView = null;
                            $scope.ad.view.currentBookingView = null;
                        });
                }
                else
                    $scope.dd.view.errorMessage = "La transaction a été refusée car votre carte n'a pas été validée.";

            }
        };

        $scope.removeSaleProductView = function(saleProductView) {
            if ($scope.ad.view.currentSaleView) {
                $scope.ad.view.currentSaleView.removeSaleProductView(saleProductView);
                if (!$scope.ad.view.currentSaleView.hasProductNotNull())
                {
                    $scope.ad.view.currentSaleView.setDelivery(null,true,0);
                    if($scope.ad.view.currentSaleView.hasGiftItemEditionType("delivery") && $scope.ad.appAttributes.hasGiftItemDeliveryCharge)
                        $scope.ad.view.currentSaleView.setDelivery("address",true,$scope.ad.appAttributes.giftItemDeliveryCharge);
                }
            }
        };

        $scope.changeProductQuantity = function(saleProductView,step) {
            $scope.dd.view.errorStockMessage = null;
            if (saleProductView.updateQuantity(step,false)) {
                if (saleProductView.quantity == 0) {
                    $scope.removeSaleProductView(saleProductView);
                }
            }
            else
                $scope.dd.view.errorStockMessage = "Vous ne pouvez pas commander plus de produits car le stock est épuisé."
        };

        $scope.onChangeCureQuantity = function(saleCureView) {
            saleCureView.onChangeQuantity()
            if (saleCureView.quantity==0)
                $scope.ad.view.currentSaleView.removeSaleCureView(saleCureView);
        };

        $scope.removeGiftItemView = function(giftItemView) {
            if ($scope.ad.view.currentSaleView) {
                $scope.ad.view.currentSaleView.removeGiftItemView(giftItemView);
                if(!$scope.ad.view.currentSaleView.hasGiftItemEditionType("delivery"))
                {
                    $scope.ad.view.currentSaleView.setDelivery(null,true,0);
                    if($scope.ad.view.currentSaleView.hasProductNotNull() && $scope.ad.appAttributes.hasProductDeliveryCharge)
                        $scope.ad.view.currentSaleView.setDelivery("address",true,$scope.ad.appAttributes.productDeliveryCharge);
                }
            }
        };

        $scope.cancel = function() {
            $scope.ad.view.currentSaleView = null;
            $scope.ad.view.currentBookingView = null;
            $scope.openLocation('home');
        };

        $scope.sendSmsActivationCode = function() {
            if (!$scope.ad.view.customerView || !$scope.ad.view.customerView.phone || $scope.dd.view.displayErrorPhoneNumber) {
                $scope.dd.view.displayError = true;
                return;
            }
            var customer = new Customer();
            $scope.ad.view.customerView.copyDataTo(customer);
            $scope.dd.view.waitServerResponse = true;
            $scope.dd.view.errorMessage = null;
            CustomerSrv.sendSmsActivationCode(customer,
                function (smsActivationCodeSent) {  //success sent
                    $scope.dd.smsActivationCodeSent = smsActivationCodeSent;
                    console.log($scope.dd.smsActivationCodeSent);
                    $scope.dd.view.isSmsActivationCodeSent = true;
                    $scope.dd.view.waitServerResponse = false;
                    $scope.dd.view.displayError = false;
                    var smsTries = CookieFactory.getCookie('flexyBeauty-smsTries');
                    if (smsTries)
                    {
                        smsTries.nb++;
                        smsTries.date = new Date();
                        CookieFactory.setCookie('flexyBeauty-smsTries',smsTries);
                        if (smsTries.nb>=3)
                            $scope.dd.view.displayCantSendSms = true;
                    }
                },function (errorCode,errorMessage) {
                    $scope.dd.view.isSmsActivationCodeSent = false;
                    $scope.dd.view.waitServerResponse = false;
                    $scope.dd.view.displayError = true;
                    $scope.dd.view.errorMessage = errorMessage;
                });
        };

        $scope.afterSaveCurrentBooking = function(booking) {
            if ($scope.ad.appAttributes.googleAnalyticsId && $scope.ad.appAttributes.googleAnalyticsId!='') {
                gtag('event', 'pageview', {
                    'event_category': 'View',
                    'event_label': '/rendezvous/finalise'
                });
            }
            if (typeof analytics !== 'undefined' && analytics)
                analytics.track("Booking Demo Signed Up");
            $scope.dd.view.waitServerResponse = false;
            $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
            $scope.ad.view.currentBookingView = null;
            $scope.dd.view.savingDone = false;
            $scope.openLocation("account");
        };

        $scope.afterSaveError = function(errorCode,errorMessage) {
            $scope.dd.view.waitServerResponse = false;
            if (errorCode=="40900")
            {
                $scope.ad.view.errorMessage = errorMessage;
                if ($scope.ad.view.currentSaleView)
                {
                    $scope.ad.view.currentSaleView.paymentsView = [];
                    $scope.ad.view.currentSaleView.change =0;
                    $scope.ad.view.currentSaleView.payedPrice = 0;
                }
                $scope.openLocation("cart");

            }
            if (errorCode=="40000")
            {
                $scope.ad.view.errorMessage = errorMessage;
                $scope.ad.view.currentSaleView = null;
                $scope.ad.view.currentBookingView = new BookingView(null, -1, $scope);
                $scope.openLocation("cart");
            }
            else
            {
                $scope.dd.view.errorMessage = errorMessage;
                $scope.getCardRegistration();
            }
        };

        $scope.afterSaveSuccess = function( bookingRes ) {
            $scope.dd.view.waitServerResponse = false;
            $scope.dd.view.savingDone = true;
            $scope.dd.view.errorMessage = null;
            if (bookingRes && bookingRes.sale && bookingRes.sale.resultPayIn) {

                var sale = bookingRes.sale;
                if (sale.resultPayIn.secureModeRedirectURL && sale.resultPayIn.secureModeRedirectURL != '') {
                    $scope.dd.view.errorMessage = "Redirection vers site 3D secure";
                    $window.open(sale.resultPayIn.secureModeRedirectURL, "_self");
                }
                else {
                    $scope.ad.view.soldSaleView = $scope.ad.view.currentSaleView;
                    $scope.ad.view.bookedBookingView = $scope.ad.view.currentBookingView;
                    $scope.ad.view.currentSaleView = null;
                    $scope.ad.view.currentBookingView = null;
                    $scope.openLocation("account");
                }

            }
            else
            {
                $scope.dd.view.errorMessage = "La transaction a été refusée par la banque. Merci de vérifier vos autorisations de paiement par Internet";
                $scope.getCardRegistration(); //renew card registration
            }
        };

        $scope.saveCurrentBookingWithoutSale  = function() {
            if ($scope.ad.view.currentBookingView) {
                $scope.ad.view.currentBookingView.saleView = null;
                $scope.ad.view.currentSaleView = null;
                $scope.saveCurrentBooking();
            }
        };

        $scope.checkCureItemServicesAndCheckOut = function(successFunction) {
            let currentBookingView = $scope.ad.view.currentBookingView;
            if(!$scope.isValidCustomerEmail()) {
                $scope.dd.view.isWithoutPayment = true;
                $scope.addEmailValidationToProcessIfNeeded();
            } else {
                if (currentBookingView && currentBookingView.getCureItemsService() && $scope.needToCheckIfCureIsUsed(currentBookingView)) {
                    let cureItemsService = currentBookingView.getCureItemsService();

                    CureItemSrv.checkCureItemServiceIsUsed(cureItemsService, function (data) {
                        let cureItemServices = data.cureItemServices;
                        if (cureItemServices != null && cureItemServices.length > 0) {
                            for (let i = 0; i < currentBookingView.bookingServicesView.length; i++) {
                                for (let j = 0; j < cureItemServices.length; j++) {
                                    if (currentBookingView.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.cureItemView.cureItemId === cureItemServices[j].cureItemId) {
                                        $scope.dd.view.cureDisplayError = true;
                                    }
                                }
                            }
                            if (!$scope.dd.view.cureDisplayError) {
                                if (successFunction != undefined)
                                    successFunction();
                            }
                        } else if (successFunction != undefined) {
                            successFunction();
                        }
                    }, function (data) {
                        if ((data == null) || data.status == null || data.status !== "200") {
                            $scope.dd.view.serverAlert = true;
                        }
                    });
                } else if (successFunction != undefined) {
                    successFunction();
                }
            }
        };

        $scope.needToCheckIfCureIsUsed = function(currentBookingView) {
            let needToCheckIfCureIsUsed = false;

            if(currentBookingView){
                for (let i = 0; i < currentBookingView.bookingServicesView.length; i++) {

                    let serviceIdFromBooking = currentBookingView.bookingServicesView[i].serviceView.serviceId,
                        servicePrice = currentBookingView.bookingServicesView[i].price;

                    if (currentBookingView.bookingServicesView[i].cureItemToServiceUsageView && servicePrice === 0 ){
                        let serviceIdFromCureItem = currentBookingView.bookingServicesView[i].cureItemToServiceUsageView.cureItemToServiceView.serviceView.serviceId;
                        if (serviceIdFromBooking === serviceIdFromCureItem) {
                            needToCheckIfCureIsUsed = true;
                            break;
                        }
                    }
                }
            }
            return needToCheckIfCureIsUsed;
        };

        $scope.saveCurrentBooking  = function() {
            $scope.dd.view.waitServerResponse = true;
            $scope.dd.view.savingDone = false;
            if ($scope.ad.view.currentBookingView && $scope.ad.view.currentBookingView.canBook())
            {
                if ($scope.ad.view.currentSaleView)
                {
                    var ssView;
                    $scope.ad.view.currentSaleView.saleServicesView = [];
                    for (var i=0; i< $scope.ad.view.currentBookingView.bookingServicesView.length;i++)
                        if (!$scope.ad.view.currentBookingView.bookingServicesView[i].cureItemToServiceUsageView) {
                            ssView = $scope.ad.view.currentSaleView.addBookingServiceOnSale($scope.ad.view.currentBookingView.bookingServicesView[i]);
                            if (ssView) {//Set hr view on sale
                                if(!$scope.ad.view.currentBookingView.bookingServicesView[i].isPackage && $scope.ad.view.currentBookingView.bookingServicesView[i].aDayHrView) {
                                    ssView.hrView = $scope.ad.view.currentBookingView.bookingServicesView[i].aDayHrView.hrView;
                                }
                                else if($scope.ad.view.currentBookingView.bookingServicesView[i].isPackage) {
                                    for (var j = 0; j < ssView.subSaleServicesView.length; j++) {
                                        if($scope.ad.view.currentBookingView.bookingServicesView[i].subBsView[j].aDayHrView && ssView.subSaleServicesView[j].serviceView.nbHrsNeeded)
                                            ssView.subSaleServicesView[j].hrView = $scope.ad.view.currentBookingView.bookingServicesView[i].subBsView[j].aDayHrView.hrView;
                                    }
                                }
                            }
                        }
                    $scope.ad.view.currentSaleView.calculateVatLines();
                    $scope.ad.view.currentBookingView.updateModel($scope.afterSaveSuccess,$scope.afterSaveError);
                }
                else
                    $scope.ad.view.currentBookingView.updateModel($scope.afterSaveCurrentBooking,$scope.afterSaveError);
            }
        };

        $scope.saveCurrentCustomer  = function() {
            $scope.dd.view.waitServerResponse = true;
            if ($scope.customerView)
                $scope.customerView.updateModel(true,$scope.afterSaveCurrentCustomer);
        };

        $scope.afterSaveCurrentCustomer = function() {
            $scope.currentCustomerFilled = true;
            $scope.dd.view.waitServerResponse = false;
        };

        $scope.hasMandatoryPayment = function() {
            if ($scope.ad.appAttributes.hasBookingPaymentMandatory)
                return true;
            if ($scope.ad.appAttributes.hasBookingPaymentOnAmount && $scope.ad.view.currentBookingView.price>=$scope.ad.appAttributes.bookingPaymentOnAmount)
                return true;
            for (var i=0;i<$scope.ad.view.currentBookingView.bookingServicesView.length;i++)
                if ($scope.ad.view.currentBookingView.bookingServicesView[i].serviceView.hasMandatoryPayment)
                    return true;
            return false;
        };

        $scope.canBookWithoutPay = function () {
            if (!$scope.ad.view.currentBookingView) {
                return false;
            }
            if (!$scope.ad.offerManager.hasAccessToFeature($scope.ad.subscriptions, $scope.ad.storeAppCode.OPTION_WEBSITE_PAYMENT) || !$scope.ad.appAttributes.hasBookingPayment) {
                return true;
            }
            //if cure exist can book without pay
            if ($scope.ad.view.currentBookingView.bookingServicesView.length == 1 && $scope.ad.view.currentBookingView.customerView.getFirstCureItemToServiceViewByServiceView($scope.ad.view.currentBookingView.bookingServicesView[0].serviceView)) {
                return true;
            } else {
                return !$scope.hasMandatoryPayment();
            }
        };

        $scope.mustPayAdvance = function () {
            if (!$scope.ad.view.currentBookingView) {
                return false;
            }
            if ($scope.ad.view.currentSaleView && $scope.ad.view.currentSaleView.hasItemsOtherThanService()) {
                return false;
            }
            if ($scope.ad.view.currentBookingView.bookingServicesView.length == 1 && $scope.ad.view.currentBookingView.customerView.getFirstCureItemToServiceViewByServiceView($scope.ad.view.currentBookingView.bookingServicesView[0].serviceView)) {
                return false;
            }
            if ($scope.ad.offerManager.hasAccessToFeature($scope.ad.subscriptions, $scope.ad.storeAppCode.OPTION_WEBSITE_PAYMENT) && $scope.ad.appAttributes.hasBookingPayment) {
                return $scope.ad.appAttributes.hasBookingPaymentAdvance && $scope.hasMandatoryPayment();
            } else {
                return false;
            }
        };

        $scope.start = function() {
            if(!$scope.ad.view.currentBookingView &&  !$scope.ad.view.currentSaleView) {
                $scope.openLocation("home");
                return;
            }

            if ($scope.ad.subscriptionsStatus.bookingSmsSecurity)
            {
                var smsTries = CookieFactory.getCookie('flexyBeauty-smsTries');
                if (smsTries)
                {
                    var now = new Date();
                    var lastTry = new Date(smsTries.date);
                    if ((now - lastTry.getTime())<1000*60*60*24) //less than one day
                    {
                        if (smsTries.nb>=3)//last try was less than one day and 3 tries
                            $scope.dd.view.displayCantSendSms = true;
                    }
                    else
                    {
                        smsTries.nb = 0;//more than one day : reset to 0
                        CookieFactory.setCookie('flexyBeauty-smsTries',smsTries);
                    }
                }
                else
                {
                    CookieFactory.setCookie('flexyBeauty-smsTries',
                        {nb : 0, date : new Date});//check that cookie can be saved
                    smsTries = CookieFactory.getCookie('flexyBeauty-smsTries');
                    if (!smsTries) {
                        $scope.dd.view.displayCantSendSms = true;
                        $scope.dd.view.cookieError = true;
                    }
                }
            }

            if (!$scope.ad.view.customerView)
            {
                $scope.ad.view.customerView = new CustomerView();
                $scope.ad.view.customerView.domainView = $scope;
            }

            if ($scope.ad.view.currentBookingView)
            {
                if (!$scope.ad.view.currentBookingView.canBook())
                {
                    $scope.ad.view.currentBookingView = null;
                    if ($scope.ad.view.currentSaleView) {
                        $scope.ad.view.currentSaleView.bookingView = null;
                        $scope.ad.view.currentSaleView.saleServicesView = [];
                    }
                }
                else
                {
                    $scope.ad.view.currentBookingView.customerView = $scope.ad.view.customerView;
                    $scope.dd.view.productsOfServicesView = $scope.ad.view.currentBookingView.getProductsOfServices();

                }
            }

            if ($scope.ad.view.currentSaleView)
                $scope.ad.view.currentSaleView.customerView = $scope.ad.view.customerView;
            // By default go to connect
            if ($scope.ad.view.customerView && $scope.ad.customerConnected ) {
                if (!$scope.ad.view.customerView.email || $scope.ad.view.customerView.email == '') {
                    $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.identity;
                    $scope.dd.view.loading = false;
                }
                else
                {
                    $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.recap;
                    CustomerSrv.loadRelatedData($scope.ad.view.customerView.getModel(), function ()
                    {
                        if ($scope.ad.view.currentBookingView)
                            $scope.ad.view.currentBookingView.bookingIndex =-1;//reinit because loadRelatedData clear index
                        if ($scope.ad.view.currentSaleView)
                            $scope.ad.view.currentSaleView.saleIndex =-1;//reinit  because loadRelatedData clear index
                        $scope.ad.view.customerView.initHistoryView();
                        if ($scope.ad.view.currentSaleView)
                            $scope.ad.view.currentSaleView.updateLoyaltyCardItem(true);

                        $scope.dd.view.loading = false;
                    },function() {
                        $scope.ad.view.currentBookingView = null;
                        $scope.ad.view.currentSaleView = null;
                        $scope.dd.view.errorMessage = "Le système de paiement n'est pas disponible."
                        $scope.dd.view.loading = false;
                    });
                }
            }
            else
                $scope.dd.view.loading = false;

            $scope.initProcess();
        };

        $scope.displayIdentityStep = function() {
            $scope.dd.view.displayStep = $scope.dd.view.checkoutDisplaySteps.identity;
            $scope.dd.view.errorMessage = null;
        };

        $scope.isClickAndCollectMode = function() {
            let isClickAndCollectMode = false;
            if(!$scope.ad.appAttributes.hasProductDelivery) {
                $scope.ad.view.currentSaleView.setDelivery(SaleDelivery.SITE, true, $scope.ad.appAttributes.productDeliveryCharge)
                isClickAndCollectMode = true;
            } else if($scope.ad.view.currentSaleView.delivery === SaleDelivery.SITE) {
                isClickAndCollectMode = true;
            }
            return isClickAndCollectMode;
        };

        $scope.saveCustomerAndContinuePaymentProcess = function() {
            $scope.ad.view.customerView.email = $scope.dd.view.customerEmailConfirmation;
            $scope.ad.view.customerView.updateModel(true, function() {
                if ($scope.dd.view.isWithoutPayment) {
                    $scope.checkCureItemServicesAndCheckOut($scope.saveCurrentBookingWithoutSale());
                } else {
                    $scope.getCardRegistration();
                    $scope.addCartToProcess();
                }
                $scope.dd.view.process.emailValidation.active = false;
                $scope.dd.view.process.card.num -= 1;
                $scope.dd.view.emailErrorMessage = null;
            }, function() {
                $scope.dd.view.emailErrorMessage = gettextCatalog("Erreur durant la validation, veuillez réessayer.");
            });
        };

        $scope.canSaveCustomerEmail = function(event) {
            let canSaveCustomerEmail;
            if (!(event.$error.required || event.$error.pattern) && $scope.dd.view.customerEmailConfirmation === $scope.dd.view.emailConfirmation) {
                canSaveCustomerEmail = true;
            }
            return canSaveCustomerEmail;
        };

        $scope.start();
    }]);



// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteCheckOutCtrl.js